import AnnualReportForm from "../../../model/AnnualReportForm";
import {useState} from "react";

const ARE_THERE_GENERATED_OUTPUTS = `Have any of your research outputs involved the generation of individual-level derived variables?`;
const EXPLAIN_OUTPUTS = `Please briefly summarise what these research outputs are and which UK Biobank application(s) they originate from.`;

/**
 * Props for this component
 */
interface ResearchOutputVariablesQuestionProps {
   form: AnnualReportForm,
   isLocked: boolean,
}

/**
 * Question regarding the generation of research output variables
 *
 * Used in: {@link ApplicantAnnualReportForm|Applicant annual report}
 * @param form An {@link AnnualReportForm} object with a saved report (Could be empty if it's a new report)
 * @param isLocked A boolean to indicate if the report is locked for editing or not
 */
export default function ResearchOutputVariablesQuestion({form, isLocked}: ResearchOutputVariablesQuestionProps) {
   // State to control the showing/hiding of the text area
   const [inputBoxShowing, setInputBoxShowing] = useState(form.hasDerivedVariablesGenerated);

   return (
      <div id="generatedOutputsQ" className="annual-report-question">
         <label id="generatedOutputsQMainText" className="question-text">{ARE_THERE_GENERATED_OUTPUTS}</label>
         {isLocked ? (
            <span className="boolean-answer">{form.hasDerivedVariablesGenerated ? 'YES' : 'NO'}</span>
         ) : (
            //Radio Button Area
            <div id="generatedOutputsQRadioArea" className="yes-or-no-radio">
               <input id="generatedOutputsQRadioYesInput" className="form-check-input" type="radio"
                      name="generatedOutputsQRadioSelection"
                      data-bs-toggle={!inputBoxShowing ? "collapse" : ""}
                      data-bs-target="#generatedOutputsQTextInput"
                      aria-expanded="false"
                      aria-controls="generatedOutputsQTextInput"
                      required
                      onChange={() => {
                         form.hasDerivedVariablesGenerated = true;
                         setTimeout(() => {
                            setInputBoxShowing(true);
                         }, 10);
                      }}
                      defaultChecked={(form.annualReportId && form.hasDerivedVariablesGenerated != null) ? (form.hasDerivedVariablesGenerated) : false}
               />
               <label id="generatedOutputsQRadioYesText" className="form-check-label"
                      htmlFor="generatedOutputsQRadioYesInput">
                  Yes
               </label>
               <input id="generatedOutputsQRadioNoInput" className="form-check-input" type="radio"
                      name="generatedOutputsQRadioSelection"
                      data-bs-toggle={inputBoxShowing ? "collapse" : ""}
                      data-bs-target="#generatedOutputsQTextInput"
                      aria-expanded="false"
                      aria-controls="generatedOutputsQTextInput"
                      required
                      onChange={() => {
                         form.hasDerivedVariablesGenerated = false;

                         setTimeout(() => {
                            setInputBoxShowing(false);
                         }, 300);
                      }}
                      defaultChecked={(form.annualReportId && form.hasDerivedVariablesGenerated != null) ? (!form.hasDerivedVariablesGenerated) : false}
               />
               <label id="generatedOutputsQRadioNoText" className="form-check-label"
                      htmlFor="generatedOutputsQRadioNoInput">
                  No
               </label>
               <div id="generatedOutputsQRadioAreaFeedback" className="invalid-feedback">
                  Please select one option.
               </div>
            </div>
         )}
         {/*Text input area*/}
         <div className="accordion accordion-flush" id="generatedOutputsQAccordion">
            <div id="generatedOutputsQTextInput"
                 className={`annual-report-question accordion-collapse collapse ${form.hasDerivedVariablesGenerated ? "show" : ""}`}
                 data-bs-parent="#generatedOutputsQAccordion">
               <span id="generatedOutputsQResourceText" className="question-text">
                  {EXPLAIN_OUTPUTS}
               </span>
               <textarea id="generatedOutputsQReasoningInput" name="lastYearResInput" className="form-control" rows={3}
                         disabled={isLocked}
                         onChange={(e) => form.researchOutputs = encodeURIComponent(e.target.value)}
                         required={inputBoxShowing != null && inputBoxShowing} minLength={100} maxLength={1000}>
         {decodeURIComponent(form.researchOutputs ? form.researchOutputs : '')}</textarea>
               <div id="lastYearResScopeFeedback" className="invalid-feedback">
                  Your answer must have between 100 and 1000 characters.
               </div>
            </div>
         </div>
      </div>
   );
}
